import axios from "axios";
import { getOptions } from "../../helpers/api";

export const auth = {
  login: (data) => {
    return axios.post("/mashhad.api/User/Authenticate", {
      username: data.username,
      password: data.password,
    }, { withCredentials: true, headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' } }); 
  },  forgetPassword: (data) => {
    return axios.post("/mashhad.api/UserManagement/forgotPassword", {
      email: data.email,
    }, { headers: { 'Content-Type': 'application/json' } }); 
  },
  verifyResetCode: (data) => {
    return axios.post("/mashhad.api/UserManagement/verifyResetCode", {
      token: data.token,
    }, { headers: { 'Content-Type': 'application/json' } }); 
  },
  resetPassword: (data) => {
    return axios.post("/mashhad.api/UserManagement/resetPassword", {
      token: data.token,
      newPassword: data.newPassword,
    }, { headers: { 'Content-Type': 'application/json' } }); 
  },
  authAmanah: (token) => {
    return axios.get(`/mashhad.api/user/amanah/authorize?token=${token}`, { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' });
  },
  logOut: (data) => {
    const { headers } = getOptions(data);
    return axios.get(`/mashhad.api/User/Logout`, headers);
  },
  validateOtp: (data) => {
    return axios.post("/mashhad.api/User/validateOtp", {
      Code: data.code,
      Reference: data.reference,
    }, { withCredentials: true, headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' } }); 
  },
};

